/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Lembaga_P2dInputs */

const en_mk_sol_lembaga_p2d = /** @type {(inputs: Mk_Sol_Lembaga_P2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producing periodic reports takes away the person who should be in the field.`)
};

const id_mk_sol_lembaga_p2d = /** @type {(inputs: Mk_Sol_Lembaga_P2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyusun laporan berkala menyita orang yang seharusnya berada di lapangan.`)
};

/**
* | output |
* | --- |
* | "Producing periodic reports takes away the person who should be in the field." |
*
* @param {Mk_Sol_Lembaga_P2dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_lembaga_p2d = /** @type {((inputs?: Mk_Sol_Lembaga_P2dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Lembaga_P2dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_lembaga_p2d(inputs)
	return en_mk_sol_lembaga_p2d(inputs)
});